import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  ConfigProvider,
  DatePicker,
  Drawer,
  Radio,
  RadioChangeEvent,
} from "antd";
import locale from "antd/es/date-picker/locale/ru_RU";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { summaryService } from "../api";
import {
  getProduct,
  getReferences,
  getReferencesFilter,
  getThread,
} from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { calcChange } from "../scripts/utils";
import BarChart from "./BarChart";
import { LineChart } from "./Charts/LineChart";

import { LineChartDouble } from "./LineChartDouble";

type Props = {
  refer: any;
};

const NumberOfMentions: any = ({ refer }: Props) => {
  const [value, setValue] = useState("today");
  const [labelsArr, setLabelsArr] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const { RangePicker } = DatePicker;
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [loadingMentions, setLoadingMentions] = useState(true);
  const [loadingGraph, setLoadingGraph] = useState(false);
  const [competitors, setCompetitors] = useState([]);
  const graph_date = [
    { graph_date: "2025-05-1", netural: 8, positive: 1 },
    { graph_date: "2025-05-2", netural: 7, positive: 2 },
    { graph_date: "2025-05-3", netural: 5, positive: 1 },
    { graph_date: "2025-05-4", netural: 6, positive: 3 },
    { graph_date: "2025-05-5", netural: 9, positive: 0 },
    { graph_date: "2025-05-6", netural: 9, positive: 0 },
    { graph_date: "2025-05-7", netural: 8, positive: 1 },
    { graph_date: "2025-05-8", netural: 8, positive: 0 },
    { graph_date: "2025-05-9", netural: 8, positive: 0 },
    { graph_date: "2025-05-10", netural: 9, positive: 0 },
    { graph_date: "2025-05-11", netural: 9, positive: 2 },
    { graph_date: "2025-05-12", netural: 7, positive: 1 },
    { graph_date: "2025-05-13", netural: 6, positive: 0 },
    { graph_date: "2025-05-14", netural: 6, positive: 0 },
    { graph_date: "2025-05-15", netural: 6, positive: 0 },
    { graph_date: "2025-05-16", netural: 6, positive: 0 },
    { graph_date: "2025-05-17", netural: 5, positive: 1 },
    { graph_date: "2025-05-18", netural: 7, positive: 1 },
    { graph_date: "2025-05-19", netural: 7, positive: 0 },
    { graph_date: "2025-05-20", netural: 7, positive: 0 },
    { graph_date: "2025-05-21", netural: 8, positive: 0 },
    { graph_date: "2025-05-22", netural: 8, positive: 0 },
    { graph_date: "2025-05-23", netural: 8, positive: 0 },
    { graph_date: "2025-05-24", netural: 8, positive: 0 },
    { graph_date: "2025-05-25", netural: 9, positive: 0 },
  ];
  const [graphData, setGraphData] = useState(graph_date);
  const [totalMentions, setTotalMentions] = useState(0);
  const [client, setClient] = useState("");
  const [previousMentions, setPreviousMentions] = useState(0);
  const referencesFilter = useSelector(getReferences);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];
  const [openDrawer, setOpenDrawer] = useState(false);
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    if (thread) {
      let params = {
        thread_id: +thread.id,
        product_id: product,
        from: dateString[0].slice(0, 10) + " 00:00:00",
        to: dateString[1].slice(0, 10) + " 23:59:59",
      };
      summaryService
        .loadShareOfVoiceInfo(params)
        .then((resp) => {
          const lables: any = [];
          lables.push(resp.client.title);
          resp.competitors.items.forEach(
            (it: any) => it.share_of_voice != 0 && lables.push(it.title)
          );
          setLabelsArr(lables);
          const data: any = [];
          data.push(resp.client.share_of_voice);
          resp.competitors.items.forEach(
            (it: any) => it.share_of_voice > 1 && data.push(it.share_of_voice)
          );
          setDataArr(data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
      setLoadingMentions(true);
      summaryService
        .loadMediaIndexInfo(params)
        .then((resp) => {
          setCompetitors(resp.competitors.items);
          setTotalMentions(resp.client.mentions);
          setClient(resp.client.title);
          let calc = calcChange(
            resp.client.mentions,
            resp.client.previous.mentions
          );

          setPreviousMentions(+calc);
          setLoadingMentions(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, dateString, product]);

  /*useEffect(() => {
    setLoadingGraph(true);
    if (thread && product) {
      let dateDiff =
        (new Date(feedFilter.to).getTime() -
          new Date(feedFilter.from).getTime()) /
        86400000;

      let params = {
        thread_id: +thread.id,
        product_id: product,
      };
      let params2 = {
        thread_id: +thread.id,
        from: dateString[0].slice(0, 10) + " 00:00:00",
        to: dateString[1].slice(0, 10) + " 23:59:59",
        filter: {
          network_id: thread.networks,
          referenceFilter: referencesFilter,
        },
      };
      if (dateDiff >= 28) {
        summaryService
          .loadClientGraph(params)
          .then((resp) => {
            let arr = resp.map((item: any, id: number) => {
              item.netural = (item.count * Number(item.netural)) / 100;
              item.negative = (item.count * Number(item.negative)) / 100;
              item.positive = (item.count * Number(item.positive)) / 100;
              return item;
            });
            console.log("jjjjjj", arr);
            setGraphData(arr);
            setLoadingGraph(false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        summaryService
          .loadTrustViewsGraph(params2)
          .then((resp) => {
            let arr = resp.smi.map((item: any, id: number) => {
              item.graph_date = item.item_date;
              item.netural = item.netural + resp.social[id].netural;
              item.negative = item.negative + resp.social[id].negative;
              item.positive = item.positive + resp.social[id].positive;
              return item;
            });
            setGraphData(arr);
            setLoadingGraph(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [thread, product, dateString, feedFilter, refer]);*/

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setValue(value);

    if (value == "today")
      setDateString([
        new Date().toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    if (value == "week") {
      const start = new Date();
      start.setDate(start.getDate() - 6);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
    if (value == "month") {
      const start = new Date();
      start.setDate(start.getDate() - 29);
      setDateString([
        start.toJSON().split("T")[0],
        new Date().toJSON().split("T")[0],
      ]);
    }
  };

  const onPeriodChange = (value: any, dateString: string[]): void => {
    setDateString(dateString);
  };

  const months = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];

  const getDate = (date: string) => {
    let dateSeparator = "-";

    if (date.includes(dateSeparator)) {
      let dateArr = date.split("-");
      let month = parseInt(dateArr[1]) - 1;

      return dateArr[2].slice(0, 2) + " " + months[month];
    }

    return date;
  };

  return (
    <div className="white-block">
      <div>
        <h1>Анализ конкурентов в отрасли</h1>
        {loadingGraph ? (
          <div className="feed-posts-loader" style={{ height: "400px" }}>
            <LoadingOutlined />
          </div>
        ) : (
          <>
            {/*<LineChartDouble graphData={graphData} />*/}
            <LineChart graphData={graphData} />
          </>
        )}
      </div>
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <div className="overflow-block">
          <p className="purple-border">
            График показывает динамику закрытых/открытых вакансий с выбором
            ретроспективы
          </p>

          <p className="title-small">Источники данных</p>

          <p className="gray-block">
            <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в
            реальном времени, что позволяет вам следить за актуальными трендами
          </p>
        </div>
      </Drawer>
    </div>
  );
};

export default NumberOfMentions;
